/* Optimal Pet — product page behaviour */
(function () {
  function initPd(root) {
    if (root.dataset.opReady) return;
    root.dataset.opReady = '1';
    var data = JSON.parse(root.querySelector('[data-op-product-json]').textContent);
    var slides = root.querySelector('[data-op-slides]');
    var thumbs = root.querySelectorAll('[data-op-thumb]');
    var idxEl = root.querySelector('[data-op-idx]');
    var n = slides ? slides.children.length : 0, cur = 0;

    function setActive(i) {
      cur = i;
      if (idxEl) idxEl.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i]; if (t && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    }
    function goTo(i, instant) {
      if (!slides || !n) return;
      i = (i + n) % n;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (slides) {
      var tm;
      slides.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); }, 80);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.opThumb); }); });
    var prev = root.querySelector('[data-op-prev]'), next = root.querySelector('[data-op-next]');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    function goToMedia(id, instant) {
      if (!slides || !id) return;
      var el = slides.querySelector('[data-media-id="' + id + '"]');
      if (el) goTo(Array.prototype.indexOf.call(slides.children, el), instant);
    }

    var vidInput = root.querySelector('[data-op-vid]');
    var price = root.querySelector('[data-op-price]'), compare = root.querySelector('[data-op-compare]'), save = root.querySelector('[data-op-save]');
    var atc = root.querySelector('[data-op-atc]'), atcLabel = root.querySelector('[data-op-atc-label]');
    var fieldsets = root.querySelectorAll('[data-op-opt]');
    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('[data-op-option-select]'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var opts = selected(), v = find(opts);
      fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-op-opt-label]'); if (l) l.textContent = (opts[i] || '').split(' — ')[0]; });
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      vidInput.value = v.id;
      price.textContent = OP.money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      compare.hidden = !onSale; save.hidden = !onSale;
      if (onSale) { compare.textContent = OP.money(v.compare_at_price); save.textContent = 'Save ' + OP.money(v.compare_at_price - v.price); }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? (root.dataset.atcLabel || 'Add to cart') : 'Sold out';
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      if (v.featured_media) goToMedia(v.featured_media.id);
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(); if (multiCover) syncCovers(); }); });

    root.querySelectorAll('[data-op-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = multiCover ? quantity : root.querySelector('input[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.opQty, 10));
        if (multiCover) syncCovers();
      });
    });


    var form = root.querySelector('form');
    var multiCover = data.handle === 'plush-couch-cover-checkered-test';
    var coverRows = [], coverBox, nativeBuy, quantity, checkoutItems;
    function coverItems() {
      var variants = [find(selected())].concat(coverRows.slice(0, Number(quantity.value) - 1).map(function (row) {
        return find(Array.from(row.querySelectorAll('select')).map(function (select) { return select.value; }));
      }));
      if (variants.some(function (variant) { return !variant || !variant.available; })) throw new Error('Please choose an available size and color for every cover.');
      var items = [];
      variants.forEach(function (variant) {
        var item = items.find(function (entry) { return entry.id === variant.id; });
        if (item) item.quantity++; else items.push({ id: variant.id, quantity: 1 });
      });
      return items;
    }
    function syncCovers() {
      var count = Math.max(1, Math.floor(Number(quantity.value) || 1));
      quantity.value = count;
      while (coverRows.length < count - 1) {
        var row = document.createElement('fieldset');
        row.className = 'op-pd__opt';
        row.style.cssText = 'border:0;border-top:1px solid #e5e5e5;padding:14px 0;margin:0';
        var legend = document.createElement('legend');
        legend.textContent = 'Cover ' + (coverRows.length + 2); row.appendChild(legend);
        var fields = document.createElement('div'); fields.style.cssText = 'display:flex;flex-wrap:wrap;gap:12px'; row.appendChild(fields);
        fieldsets.forEach(function (source, optionIndex) {
          var label = document.createElement('label'); label.style.cssText = 'display:block;flex:1;min-width:140px;font-size:13px';
          label.appendChild(document.createTextNode(optionIndex === 0 ? 'Size' : 'Color'));
          var select = document.createElement('select'); select.style.cssText = 'display:block;width:100%;min-height:44px;margin-top:5px;padding:8px;border:1px solid #bbb;border-radius:6px;background:#fff;color:#252530;font:inherit';
          source.querySelectorAll('[data-op-option-select] option').forEach(function (input) { var option = input.cloneNode(true); option.selected = input.selected; select.appendChild(option); });
          label.appendChild(select); fields.appendChild(label);
        });
        coverRows.push(row); coverBox.appendChild(row);
      }
      coverRows.forEach(function (row, index) { row.hidden = index >= count - 1; });
      coverBox.hidden = count === 1;
      checkoutItems.replaceChildren();
      coverRows.slice(0, count - 1).forEach(function (row, index) {
        var variant = find(Array.from(row.querySelectorAll('select')).map(function (select) { return select.value; }));
        if (!variant) return;
        ['id', 'quantity'].forEach(function (key) {
          var input = document.createElement('input'); input.type = 'hidden';
          input.name = 'shopify-additional-items[' + (index + 1) + '][' + key + ']';
          input.value = key === 'id' ? variant.id : 1; checkoutItems.appendChild(input);
        });
      });
    }
    if (multiCover && form) {
      quantity = form.querySelector('[name="quantity"]');
      quantity.removeAttribute('name');
      var primaryQuantity = document.createElement('input'); primaryQuantity.type = 'hidden'; primaryQuantity.name = 'quantity'; primaryQuantity.value = '1'; form.appendChild(primaryQuantity);
      checkoutItems = document.createElement('div'); checkoutItems.hidden = true; form.appendChild(checkoutItems);
      coverBox = document.createElement('div'); coverBox.dataset.opCoverChoices = '';
      var heading = document.createElement('p'); heading.textContent = 'Choose a size and color for each additional cover.'; heading.style.cssText = 'font-size:14px;margin:14px 0 0'; coverBox.appendChild(heading);
      form.insertBefore(coverBox, form.querySelector('.op-pd__buy'));
      nativeBuy = form.querySelector('.op-pd__dyn');
      atc.addEventListener('click', function (event) { if (Number(quantity.value) > 1) { event.preventDefault(); event.stopImmediatePropagation(); addCovers(event); } }, true);
      coverBox.addEventListener('change', syncCovers);
      quantity.addEventListener('change', syncCovers); quantity.addEventListener('input', syncCovers); syncCovers();
    }
    async function addCovers(event) {
      var multiple = multiCover && Number(quantity.value) > 1;
      if (typeof window.upcartOpenCart !== 'function' && !multiple) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (atc.disabled) return;
      atc.disabled = true;
      var originalLabel = atcLabel.textContent;
      var errorBox = form.querySelector('[data-op-cart-error]');
      if (errorBox) errorBox.remove();
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: multiple ? JSON.stringify({items: coverItems()}) : new FormData(form),
          headers: multiple ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' }
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
        if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); else location.href = window.Shopify.routes.root + 'cart';
      } catch (error) {
        errorBox = document.createElement('p');
        errorBox.dataset.opCartError = '';
        errorBox.setAttribute('role', 'alert');
        errorBox.textContent = error.message;
        form.appendChild(errorBox);
      } finally {
        atc.disabled = false;
        atcLabel.textContent = originalLabel;
      }
    }
    if (form) form.addEventListener('submit', addCovers, true);

    if (root.dataset.initialMedia) window.addEventListener('load', function () { goToMedia(root.dataset.initialMedia, true); });

    function rating() {
      var rv = document.querySelector('[data-op-reviews]'), btn = root.querySelector('[data-op-rating]');
      if (!rv || !btn || !(+rv.dataset.count > 0)) return;
      var avg = parseFloat(rv.dataset.avg), count = +rv.dataset.count;
      btn.querySelector('[data-op-rating-stars]').style.setProperty('--r', (avg * 20) + '%');
      btn.querySelector('[data-op-rating-text]').textContent = avg.toFixed(1) + ' · ' + count + (count === 1 ? ' review' : ' reviews');
      btn.hidden = false;
      btn.onclick = function () { rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rating); else rating();
  }
  function boot() { document.querySelectorAll('[data-op-checkered-pd]').forEach(initPd); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
/* Mobile sticky add-to-cart bar: appears once the main buy button has scrolled out of view. */
(function () {
  function initBar(root) {
    if (root.querySelector('.op-pd__bar')) return;
    var buy = root.querySelector('.op-pd__buy'), atc = root.querySelector('[data-op-atc]');
    var price = root.querySelector('[data-op-price]'), title = root.querySelector('.op-pd__title');
    if (!buy || !atc || !price || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'op-pd__bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="op-pd__bar-info"><strong></strong><span></span></div><button type="button" class="op__btn op-pd__bar-btn" tabindex="-1"></button>';
    root.appendChild(bar);
    var bTitle = bar.querySelector('strong'), bMeta = bar.querySelector('span'), bBtn = bar.querySelector('button');
    function sync() {
      bTitle.textContent = title ? title.textContent.trim() : '';
      var labels = [].map.call(root.querySelectorAll('[data-op-opt-label]'), function (l) { return l.textContent.trim(); });
      bMeta.textContent = price.textContent.trim() + (labels.length ? ' · ' + labels.join(' / ') : '');
      bBtn.textContent = atc.textContent.trim(); bBtn.disabled = atc.disabled;
    }
    sync();
    new MutationObserver(sync).observe(root.querySelector('.op-pd__info') || root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    bBtn.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    new IntersectionObserver(function (es) {
      var e = es[0], below = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', below); bar.setAttribute('aria-hidden', below ? 'false' : 'true');
      bBtn.tabIndex = below ? 0 : -1;
    }).observe(buy);
  }
  function boot() { document.querySelectorAll('[data-op-checkered-pd]').forEach(initBar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
